"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extractStyle = exports.Leaf = exports.Element = void 0;
var react_1 = __importStar(require("react"));
var slate_react_1 = require("slate-react");
var slate_1 = require("slate");
// Put this at the start and end of an inline component to work around this Chromium bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
var InlineChromiumBugfix = function () {
  return react_1.default.createElement("span", {
    contentEditable: false,
    style: {
      fontSize: 0
    }
  }, "$", String.fromCodePoint(160) /* Non-breaking space */);
};
var Element = function (props) {
  var attributes = props.attributes,
    children = props.children,
    element = props.element;
  var selected = (0, slate_react_1.useSelected)();
  var focused = (0, slate_react_1.useFocused)();
  var style = extractStyle(element);
  switch (element.type) {
    case 'blockquote':
      return react_1.default.createElement("blockquote", __assign({}, attributes, {
        style: style
      }), children);
    case 'h1':
      return react_1.default.createElement("h1", __assign({}, attributes, {
        style: style
      }), children);
    case 'h2':
      return react_1.default.createElement("h2", __assign({}, attributes, {
        style: style
      }), children);
    case 'li':
      return react_1.default.createElement("li", __assign({}, attributes, {
        style: style
      }), children);
    case 'ul':
      return react_1.default.createElement("ul", __assign({}, attributes, {
        style: style
      }), children);
    case 'ol':
      return react_1.default.createElement("ol", __assign({}, attributes, {
        style: style
      }), children);
    case 'a':
      return react_1.default.createElement("a", __assign({}, attributes, {
        href: element.href,
        style: {
          boxShadow: selected ? '0 0 0 3px #ccc' : 'none'
        }
      }), react_1.default.createElement(InlineChromiumBugfix, null), children, react_1.default.createElement(InlineChromiumBugfix, null));
    case 'img':
      return react_1.default.createElement("div", __assign({}, attributes, {
        style: style
      }), react_1.default.createElement("img", {
        src: element.src,
        alt: "this is a text description",
        style: __assign(__assign({}, style.width && {
          width: style.width
        }), {
          maxWidth: style.maxWidth || '100%',
          boxShadow: "".concat(selected && focused ? '0 0 0 3px #B4D5FF' : 'none')
        })
      }), react_1.default.createElement("div", null, children));
    case 'youtube':
      return react_1.default.createElement("div", __assign({}, attributes, {
        style: __assign({
          boxShadow: "".concat(selected && focused ? '0 0 0 3px #B4D5FF' : 'none')
        }, style.height ? {} : {
          position: 'relative',
          paddingTop: "".concat(9 / 16 * 100, "%")
        })
      }), react_1.default.createElement("iframe", {
        title: "YouTube Player",
        src: element.src,
        style: __assign({
          //for responsive size
          position: 'absolute',
          left: 0,
          top: 0,
          width: '100%',
          height: '100%',
          border: 0
        }, style),
        allowFullScreen: true
      }), children);
    case 'html':
      return react_1.default.createElement("div", __assign({}, attributes, {
        style: {
          display: 'block',
          boxShadow: "".concat(selected && focused ? '0 0 0 3px #B4D5FF' : 'none')
        }
      }), react_1.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: element.value
        }
      }), react_1.default.createElement("div", null, children));
    default:
      return react_1.default.createElement("p", __assign({}, attributes, {
        style: style
      }), children);
  }
};
exports.Element = Element;
var Leaf = function (_a) {
  var attributes = _a.attributes,
    children = _a.children,
    leaf = _a.leaf;
  var style = extractStyle(leaf);
  return react_1.default.createElement("span", __assign({}, attributes, {
    style: style
  }), children);
};
exports.Leaf = Leaf;
function extractStyle(obj) {
  var style = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, obj.textDecoration && {
    textDecoration: obj.textDecoration
  }), obj.fontStyle && {
    fontStyle: obj.fontStyle
  }), obj.fontFamily && {
    fontFamily: obj.fontFamily
  }), obj.fontWeight && {
    fontWeight: obj.fontWeight
  }), obj.fontSize && {
    fontSize: obj.fontSize
  }), obj.lineHeight && {
    lineHeight: obj.lineHeight
  }), obj.backgroundColor && {
    backgroundColor: obj.backgroundColor
  }), obj.color && {
    color: obj.color
  }), obj.textAlign && {
    textAlign: obj.textAlign
  }), obj.width && {
    width: obj.width
  }), obj.height && {
    height: obj.height
  }), obj.display && {
    display: obj.display
  }), obj.position && {
    position: obj.position
  });
  if (obj.type === 'p') {
    style.margin = 0;
  }
  if (obj.type === 'blockquote') {
    style.borderLeft = 'solid 3px lightgray';
    style.paddingLeft = 10;
  }
  if (obj.code) {
    style.backgroundColor = 'lightgray';
    style.padding = 2;
    style.fontSize = 14;
    style.borderRadius = 3;
  }
  return style;
}
exports.extractStyle = extractStyle;
function Preview(props) {
  var content = props.content;
  var renderElement = (0, react_1.useCallback)(function (props) {
    return react_1.default.createElement(Element, __assign({}, props));
  }, []);
  var renderLeaf = (0, react_1.useCallback)(function (props) {
    return react_1.default.createElement(Leaf, __assign({}, props));
  }, []);
  var editor = (0, react_1.useMemo)(function () {
    return (0, slate_react_1.withReact)((0, slate_1.createEditor)());
  }, []);
  return react_1.default.createElement(slate_react_1.Slate, {
    editor: editor,
    value: Array.isArray(content) ? content : [],
    onChange: function () {
      return 0;
    }
  }, react_1.default.createElement(slate_react_1.Editable, {
    readOnly: true,
    renderElement: renderElement,
    renderLeaf: renderLeaf
  }));
}
exports.default = Preview;